// @flow
import React, { useContext } from 'react';

import { EstimateContext } from '../../contexts/EstimateContext';
import { StyledSpan } from '../../common-utils/styledComponents';
import { NativeInferencePoolContext } from '../../contexts/NativeInferencePoolContext';

import { SecondaryTopBar } from './SecondaryTopBar';
import { getEstimateSections } from './utils';

export const NativeInferencePoolBreadcrumbs = () => {
  const estimate = useContext(EstimateContext);
  const nativeInferencePoolDetails = useContext(NativeInferencePoolContext);
  const nativeInferencePoolName = nativeInferencePoolDetails?.name;

  return (
    <SecondaryTopBar
      sectionsToShow={[
        ...getEstimateSections(estimate),
        <StyledSpan key="native-inference-pool"> Inference Pool </StyledSpan>,
        <StyledSpan key="native-inference-pool-name"> {nativeInferencePoolName} </StyledSpan>,
      ]}
    />
  );
};
